<template>
    <slot name="header">

        <!-- topNav -->
        <div class="topNav">
            <div class="inside">
                <!-- 왼쪽 메뉴 -->
                <div class="left" @click="clickHandler('left')">
                    <!-- 로고 -->
                    <img v-if      = "params.pageLeftDiv ==='logo'" :src="require('@/static/img/topNav/small_logo.png')"  style="width:25px; height: 25px;" />
                    
                    <!-- 로고 페이지 이동 기능 X -->
                    <img v-else-if = "params.pageLeftDiv ==='logoNoFunc'" :src="require('@/static/img/topNav/small_logo.png')"  style="width:25px; height: 25px;" />

                    <!-- 뒤로가기 -->
                    <img v-else-if = "params.pageLeftDiv ==='back'" :src="require('@/static/img/left_arrow_ico.svg')"  style="width:25px; height: 25px;" />
                    
                    <!-- 메뉴 -->
                    <img v-else-if = "params.pageLeftDiv ==='menu'" :src="require('@/static/img/topNav/menu_ico.svg')" style="width:20px; height: 10px;" />
                    <!-- 빈 영역 -->
                    <div v-else-if = "params.pageLeftDiv === 'none'" style="width:20px; height: 10px;">

                    </div>
                </div>
                <!-- 중간 메뉴 -->
                <div class="middle" @click="clickHandler('mid')">
                    <!-- 페이지명만 있을경우 -->
                    <div v-if="params.pageMidDiv === 'pgNmOnly'" style="height: 44px;" >
                        <div class="mainTitle">
                            {{ params.pageTitle }}
                        </div>
                    </div>
                    <!-- 페이지명(로고)과 서브 타이틀이 있을 경우 -->
                    <div v-else-if="params.pageMidDiv === 'logoSub'" >
                        <div class="mainTitle">
                            <img :src="require('@/static/img/wiselab_logo.png')"  style="height: 25px;" />
                        </div>
                        <div v-if="params.subPageTitle !=null && params.subPageTitle != ''" class="subTitle">
                            ({{ params.subPageTitle }})
                        </div>
                    </div>
                    <!-- 페이지명과 서브 타이틀이 있을 경우 -->
                    <div v-else-if="params.pageMidDiv === 'pgNmSub'" >
                        <div class="mainTitle">
                            {{ params.pageTitle }}
                        </div>
                        <div v-if="params.subPageTitle !=null && params.subPageTitle != ''" class="subTitle">
                            ({{ params.subPageTitle }})
                        </div>
                    </div>
                    <!-- 빈 영역 -->
                    <div v-else-if="params.pageMidDiv === 'none'" style="width:20px; height: 10px;">

                    </div>
                </div>
                <!-- 오른쪽 메뉴 -->
                <div class="right" @click="clickHandler('right')" style=" display: flex; flex-direction: column;  align-items: flex-end;">
                    <!-- 로고 -->
                    <img v-if      = "params.pageRightDiv === 'logo'" :src="require('@/static/img/topNav/small_logo.png')" style="width:25px; height: 25px;" />
                    <!-- 마이페이지 -->
                    <img v-else-if = "params.pageRightDiv === 'myPage'" :src="require('@/static/img/bottomNav/bottom_menu_ico2.svg')" style="width:25px; height:25px;"/>
                    <!-- 빈 영역 -->
                    <div v-else-if = "params.pageRightDiv === 'none'"></div>
                </div>
            </div>
        </div>

    </slot>
</template>

<script>

import baseMixins from '@/views/common/mixins/baseMixins.vue'
import * as types from '@/store/mutation-types'
import { SessionUtil } from '@/utils/sessionUtil.js'
import { WebUtil }     from '@/utils/webUtil.js'
import { right } from '@popperjs/core'

export default {
    mixins: [baseMixins],
    data: function() {
        return {
            showLeftMenu : '',
            isLoginMenu : true,
            isDetlMenu  : true,
            isMainMenu  : true,
            isShowChild: false,
            hasChildren: false,
            selectedChild: null,
            children: [],
            params: {
                pageLeftDiv  : '',      // 페이지 왼쪽 메뉴 구분값
                pageMidDiv   : '',      // 페이지 중간 메뉴 구분값
                pageRightDiv : '',      // 페이지 오른쪽 메뉴 구분값
                pageTitle    : '',      // 페이지 타이틀 영역
                subPageTitle : '',      // 서브 타이틀 영역
                routerDiv    : '',      // router 구분 값
                routerVal    : '',      // router 동작 값
            }
            
        }
    },
    methods: {
        init: function() {
            let $this = this;
            $this.initData();
            $this.emitter.on('onChangeTopMenu', (data) => {
                $this.getPgDiv();
            });
        },
        initData: function() {
            let $this = this;
            // $this.getTopMenu();
        },
        /* ** baseMixins의 상단 메뉴 전체 세팅 데이터 불러오기 
            1) pageLeftDiv : 상단 메뉴 좌측 세팅
                - logo       : 로고
                - back       : 뒤로가기
                - menu       : 사이드 바 메뉴
                - none       : 빈 영역
            2) pageMidDiv    : 상단 메뉴 중간 세팅
                - pgNmSub    : 페이지명 + 서브타이틀
                - pgNmOnly   : 페이지명만
                - logoSub    : 로고 + 서브타이틀
                - none       : 빈 영역
            3) pageRightDiv  : 상단 메뉴 우측 세팅
                - logo       : 로고
                - myPage     : 메인화면에서의 myPage
                - none       : 빈 영역
            4) pageTitle     : 페이지의 타이틀
            5) subPageTitle  : 페이지의 서브 타이틀
            -- 6 / 7 번은 기본 동작 이외에 필요 시 사용합니다.
            6) routerDiv    : Router 사용 구분
              - 동작 구분    : 지정 하지 않을 시 빈값 (push / replace / go / back)
            7) routerVal     : Router 경로 및 동작 구분   
              - { mloc:'', rloc :'', param:''} 형태로 데이터 전달
                - mloc   : left / mid / right
                - rloc   : 이동 할 router 경로
                - params : 이동 시 전달 할 파라미터 
                ex) {mloc: 'left' , rloc : 'Home' ,params: this.info}
                왼쪽메뉴를 누르면 router.push 로 Home 으로 이동 this.info 값을 전달
        */
        getPgDiv(){
            const $this = this;
            $this.params.pageLeftDiv  = $this.getPageLeftDiv();
            $this.params.pageMidDiv   = $this.getPageMidDiv();
            $this.params.pageRightDiv = $this.getPageRightDiv();
            $this.params.pageTitle    = $this.getPageTitle();
            $this.params.subPageTitle = $this.getSubPageTitle();
            $this.params.routerDiv    = $this.getRouterDiv();
            $this.params.routerVal    = $this.getRouterVal();

        },
        clickHandler(locDiv){
            const $this = this;
            let leftDiv     = $this.params.pageLeftDiv;
            let midDiv      = $this.params.pageMidDiv;
            let rightDiv    = $this.params.pageRightDiv;

            let routerDiv   = $this.params.routerDiv;
            let routerVal   = $this.params.routerVal;
        
            let mLoc   = null;
            let rLoc   = null;
            let params = null;


            if(WebUtil.isNotNull(routerDiv)){
                if(WebUtil.isNull(routerVal)){
                    $this.alert("페이지 이동 중 오류가 발생하였습니다.");
                    return false;
                } else {
                    mLoc   = routerVal.mloc;
                    rLoc   = routerVal.rloc;
                    params = routerVal.params;
                }
            }
            
            // 왼쪽 메뉴
            if(locDiv  === 'left'){
                // 로고
                if(leftDiv === 'logo'){
                    // 20250312 기준 동작 X
                    if(routerDiv){
                        if(mLoc == 'left'){
                            $this.setRouter(rLoc, params, routerDiv);
                        }
                    } else {
                        // 20250312 기준 동작 X
                    }
                } 
                // 뒤로가기
                else if(leftDiv === 'back'){
                    if(routerDiv){
                        if(mLoc === 'left'){
                            $this.setRouter(rLoc, params, routerDiv);
                        }
                    } else {
                        $this.$router.back();
                    }
                }
                // 메뉴
                else if(leftDiv === 'menu'){
                    $this.toggleSidebar();
                }
                else if(leftDiv === 'none'){
                    // 동작 X
                }
            }
            // 중간 메뉴
            else if(locDiv ==='mid'){
                if(midDiv === 'pgNmSub'){
                    $this.setRouter('Home',params, 'replace');
                }
                else if(midDiv ==='pgNmOnly'){
                    // 20250317 동작 X
                }
                else if(midDiv === 'logoSub'){
                    $this.setRouter('Home',params, 'replace');
                }
                else if(midDiv ==='none'){
                    // 동작 X
                }
            }
            // 우측 메뉴
            else if(locDiv ==='right'){
                if(rightDiv === 'logo'){
                    $this.setRouter('Home',params, 'replace');
                }
                else if(rightDiv === 'myPage'){
                    const sendParam = {'userId': SessionUtil.getUserId(), 'from':'stat'};
                    $this.setRouter('PifoMng', sendParam);
                }
                else if(rightDiv === 'none'){
                    // 동작 X
                }
            }
        },

        // onChangeChild: function() {
        //     let $this = this;
        //     // const emitter = $this.$store.getters.emitter;
        //     $this.emitter.emit('onChangeChild', $this.selectedChild);
        // },
        getChildren: function() {
            let $this = this;
            // console.log($this.children);
            // console.log(SessionUtil.getChildren());
            
            $this.children = SessionUtil.getChildren();
            if ( !!$this.children && $this.children.length > 0 ) {
                $this.hasChildren = true;
                if ( !$this.selectedChild ) {

                    
                    if ( !!$this.$store.getters.selectedChild ) {
                        $this.selectedChild = $this.$store.getters.selectedChild;
                    } else {
                        $this.selectedChild = $this.children[0];
                    }

                    const emitter = $this.$store.getters.emitter;
                    emitter.emit('onChangeChild', $this.selectedChild);
                }
            } else {
                $this.hasChildren = false;
            }            
        },
        toggleSidebar: function() {
            let isShow = this.$store.getters.sidebar;
            this.$store.commit(types.SIDE_BAR, !isShow);
        },
        onChangeChildren: function() {
            this.getChildren();
        },
        onChangeVisibleChild: function(isShow) {
            this.isShowChild = isShow;
        },
        onChangeMainMenu: function(isMainMenu) {
            this.isMainMenu = isMainMenu;
        },
        onClearChildInfo: function() {
            this.resetData();
        },
        onSelectedChild: function(stdtNo) {
            let $this = this;
            const _child = _.find($this.children, function(child) {
                return child.stdtNo === stdtNo.toString();
            });
            $this.selectedChild = _child;
        },
        resetData: function() {
            this.isMainMenu    = true;
            this.isShowChild   = false;
            this.hasChildren   = false;
            this.selectedChild = null;
            this.children      = [];
        },
        
    },
    watch: {
        'selectedChild': function(newVal, oldVal) {
            // console.log(newVal);
            if ( newVal != oldVal ) {
                this.$store.commit(types.SELECTED_CHILD, this.selectedChild);
                const emitter = this.$store.getters.emitter;
                emitter.emit('onChangeChild', this.selectedChild);
            }
        },
        // 'children': function(newVal, oldVal) {
        //     console.log(newVal, oldVal);
        // }
    },
    computed: {
     
        // getPageTitle() {
        //     // console.log('this.$store.getters.pageTitle_2',this.$store.getters.pageTitle_2);
        //     return this.$store.getters.pageTitle2;
        // },
        // getTopMenu(){
        //     let topMenu = this.getTopMenu();
        //     console.log("topMenu",topMenu);
        // }
        // hasChildren() {
        //     console.log('hasChildren : ' + SessionUtil.getChildren());
        //     if ( !!$this.children && $this.children.length > 0 ) {
        //         return true;
        //     } else {
        //         return false;
        //     }
            // if ( !!this.$store.getters.children || this.$store.getters.children.length > 0 ) {
            
            // store.commit(types.CHILDREN  , JSON.stringify(children));
            // if ( !!this.children && this.children.length > 0 ) {
            //     return true;
            // } else {
            //     return false;
            // }
        // },
        // isMainMenu() {
        //     console.log('isMainMenu : ' + this.$store.getters.mainMenu);
        //     this.getChildren();
        //     return this.$store.getters.mainMenu;
        // },
        // visibleChild: function() {
        //     console.log('visibleChild : ' + this.$store.getters.enableChild);
        //     this.getChildren();
        //     return this.$store.getters.enableChild;
        // }
    },
    beforeMount(){
        const $this = this;
        $this.getPgDiv();
    },
    mounted: function() {
        let $this = this;
        // this.getTopMenu();
        $this.init();
        // $this.emitter.on('onChangeChildren'    , $this.onChangeChildren);       // 헤더의 아이들 정보가 변경이 되었을 경우
        // $this.emitter.on('onChangeVisibleChild', $this.onChangeVisibleChild);   // 헤더의 아이들 콤보박스 표시 여부
        // $this.emitter.on('onSelectedChild'     , $this.onSelectedChild);        // 아이메인 페이지에서 아이를 선택할 때 아이들 콤보박스 선택 변경
        // const emitter = store.getters.emitter;
        // emitter.on('onClearChildInfo'    , $this.onClearChildInfo);
        // emitter.on('onChangeMainMenu'    , $this.onChangeMainMenu);       // 헤더의 햄버거 메뉴 표시 여부
    },
}

</script>
